import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { VideosDataService, VideosColumnsService } from '../../../services';
import { Video, VideosResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-video-details',
  templateUrl: './video-details.component.html',
  styleUrls: ['./video-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class VideoDetailsComponent implements OnInit, OnDestroy {

  public video: Video = {};
  public videos: Video[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private videosDataService: VideosDataService,
    private videosColumnsService: VideosColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Video - Details');
        this.getVideo(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.video !== 'undefined') {
      this.video = this.dynamicDialogConfig.data.video;
    }
    this.columns = this.videosColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getVideo(id: number): void {
    this.isLoading = true;
    this.videosDataService.getVideo(id).subscribe((response: Video|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.video = response;
      }
    });
  }

  list() {
    this.router.navigate(['/videos']);
  }

  add() {
    this.router.navigate(['/videos/add']);
  }

  edit() {
    this.router.navigate(['/videos/edit/' + this.video.id]);
  }

}
@Component({
  selector: 'app-video-details',
  templateUrl: './video-details.component.html',
  styleUrls: ['./video-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogVideoDetailsComponent extends VideoDetailsComponent {
}

